export default function analytics (state = {}, action) {
    switch (action.type) {
        case 'SET_LAST_ENTITY':
            return {
                ...state,
                lastTrackedActionEntity: action.last_entity
            };
        case 'SET_LAST_SERVICE_PROVIDER':
            return {
                ...state,
                lastTrackedActionServiceProvider: action.last_service_provider
            };
        default:
            return state;
    }
}
